"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOk = exports.MessageBoxDialog = void 0;
var Dialog_1 = require("./Dialog");
var react_1 = __importDefault(require("react"));
var morse_react_1 = require("morse-react");
var MessageBoxDialog = function (props) {
    var dialogProps = __rest(props, []);
    return (react_1.default.createElement(Dialog_1.Dialog, __assign({}, dialogProps, { allowDismiss: true, buttons: react_1.default.createElement(morse_react_1.Button, { onClick: function () {
                props.onDismissed && props.onDismissed();
            }, styleOptions: { pull: morse_react_1.Pull.Center } }, "OK") })));
};
exports.MessageBoxDialog = MessageBoxDialog;
var useOk = function (dialogDetails) {
    var dialogBroker = Dialog_1.useDialog();
    return {
        show: function (message, title) {
            return new Promise(function (resolve) {
                dialogBroker.show(react_1.default.createElement(exports.MessageBoxDialog, { key: morse_react_1.PortalManager.getPortalCount(), title: title !== null && title !== void 0 ? title : dialogDetails.title, onDismissed: function () {
                        dialogBroker.close();
                        resolve();
                    } }, message !== null && message !== void 0 ? message : dialogDetails.message));
            });
        },
        close: function () {
            if (dialogBroker) {
                dialogBroker.close();
            }
        },
    };
};
exports.useOk = useOk;
//# sourceMappingURL=MessageBoxDialog.js.map